export const CHANGE_RATE_DETAIL = 'CHANGE_RATE_DETAIL';
export const CHANGE_RATE_DESCRIPTION = 'CHANGE_RATE_DESCRIPTION';